import { c as _c } from "react/compiler-runtime";
import { chakra } from '@chakra-ui/react';
import { showLinkModal } from '@src/components/sco/RichMarkdownInput/utilities/blocks';
import { Element, Node, Transforms } from 'slate';
import { RenderElementProps, useSelected, useSlate } from 'slate-react';

// Define a custom type for link elements
interface LinkElementType extends Element {
  url: string;
  type: string;
}
type LinkElementProps = RenderElementProps & {
  element: LinkElementType;
};
export function LinkElement(props) {
  const $ = _c(16);
  const editor = useSlate();
  const selected = useSelected();
  if (props.element.url?.startsWith("mention:")) {
    let t0;
    if ($[0] !== props.attributes || $[1] !== props.children) {
      t0 = <span {...props.attributes}>{props.children}</span>;
      $[0] = props.attributes;
      $[1] = props.children;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] !== editor || $[4] !== props.element || $[5] !== selected) {
    t0 = e => {
      if (e.ctrlKey || e.metaKey) {
        return;
      }
      e.preventDefault();
      if (selected) {
        const linkText = Node.string(props.element);
        const path = props.element.url ? editor.selection.anchor.path.slice(0, -1) : editor.selection.anchor.path;
        showLinkModal(props.element.url || "", linkText || "", "Edit Link", (url, label) => {
          if (url) {
            Transforms.setNodes(editor, {
              url
            }, {
              at: path
            });
            if (label && label !== linkText && label !== url) {
              for (let i = props.element.children.length - 1; i >= 0; i--) {
                Transforms.removeNodes(editor, {
                  at: [...path, i]
                });
              }
              Transforms.insertNodes(editor, {
                text: label
              }, {
                at: [...path, 0]
              });
            }
          }
        }, () => {
          Transforms.unwrapNodes(editor, {
            at: path
          });
        });
      }
    };
    $[3] = editor;
    $[4] = props.element;
    $[5] = selected;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const handleClick = t0;
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "blue.600"
    };
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== selected) {
    t2 = selected ? {
      boxShadow: "0 0 0 2px #B4D5FF"
    } : {};
    $[8] = selected;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = props.element?.url || "#";
  let t4;
  if ($[10] !== handleClick || $[11] !== props.attributes || $[12] !== props.children || $[13] !== t2 || $[14] !== t3) {
    t4 = <chakra.a {...props.attributes} _hover={t1} color="blue.500" css={t2} href={t3} target="_blank" textDecoration="underline" onClick={handleClick}>{props.children}</chakra.a>;
    $[10] = handleClick;
    $[11] = props.attributes;
    $[12] = props.children;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}